import React from 'react';
import { Users } from 'lucide-react';
import { AnswerQualityHint } from './AnswerQualityHint';

interface Step3Data {
  target_audience: string;
}

interface Step3AudienceProps {
  data: Step3Data;
  onChange: (data: Step3Data) => void;
}

export function Step3Audience({ data, onChange }: Step3AudienceProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <Users className="w-4 h-4" />
          Wie zijn jouw ideale klanten?
        </label>
        <textarea
          value={data.target_audience}
          onChange={(e) => onChange({ ...data, target_audience: e.target.value })}
          rows={6}
          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-lg resize-none"
          placeholder="Gezinnen uit de buurt tussen 30-50 jaar die bewust bezig zijn met gezonde voeding. Ze willen lekker brood zonder rommel, en waarderen ambacht en lokale producten."
          autoFocus
        />
        <AnswerQualityHint length={data.target_audience.trim().length} />
      </div>
    </div>
  );
}

